import { Grid, GridColumn } from "@modernatx/ui-kit-react";
import React from "react";

import { PaymentForm } from "@/components/PaymentForm";
import InvoicePaymentScheduleForm from "@/components/Payments/AutoPayModal/InvoicePaymentScheduleForm";
import PaymentMethodCard from "@/components/Payments/AutoPayModal/PaymentMethodCard";
import {
  PaymentScheduleOptions,
  PaymentSelection
} from "@/components/Payments/AutoPayModal/SchedulePayModal";
import { PaymentMethod } from "@/types/PaymentMethod";

interface SchedulePayModalContentProps {
  invoiceId?: string;
  showAddPaymentMethod?: boolean;
  paymentFormSubmitRef?: React.MutableRefObject<
    (() => Promise<PaymentMethod | undefined>) | undefined
  >;
  selectedPayment?: PaymentSelection;
  setSelectedPayment?: React.Dispatch<React.SetStateAction<PaymentSelection>>;
  paymentScheduleOptions: PaymentScheduleOptions;
  setPaymentScheduleOptions: React.Dispatch<
    React.SetStateAction<PaymentScheduleOptions>
  >;
  loadingScheduledPayment?: boolean;
  paymentMethods: {
    all: PaymentMethod[];
    default?: PaymentMethod;
    loading: boolean;
    error?: string | null;
  };
  isInvoiceOverdue?: boolean;
}

export const SchedulePayModalContent: React.FC<
  SchedulePayModalContentProps
> = ({
  invoiceId,
  showAddPaymentMethod,
  paymentFormSubmitRef,
  selectedPayment,
  setSelectedPayment,
  paymentScheduleOptions,
  setPaymentScheduleOptions,
  paymentMethods,
  isInvoiceOverdue
}) => {
  return (
    <>
      <InvoicePaymentScheduleForm
        invoiceId={invoiceId}
        paymentScheduleOptions={paymentScheduleOptions}
        setPaymentScheduleOptions={setPaymentScheduleOptions}
        isInvoiceOverdue={isInvoiceOverdue}
      />
      <PaymentMethodCard
        defaultPaymentMethod={paymentMethods.default}
        allPaymentMethods={paymentMethods.all}
        paymentMethodError={paymentMethods.error}
        selectedPayment={selectedPayment}
        setSelectedPayment={setSelectedPayment}
      />
      <Grid sx={{ mt: "spacing-7" }}>
        <GridColumn>
          {showAddPaymentMethod && (
            <PaymentForm
              setSubmitRef={(fn) => {
                if (paymentFormSubmitRef) {
                  paymentFormSubmitRef.current = fn;
                }
              }}
            />
          )}
        </GridColumn>
      </Grid>
    </>
  );
};
